<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 13:27:18
 * @fileName     : 
 * @Description  : 我的开票详情
-->
<template>
  <el-drawer class="fin-received-invoice-detail" :title="title" v-loading="loading" :visible.sync="dialogDrawer" direction="rtl" :wrapperClosable="false"
    size="80%" :before-close="closeDrawer">
    <div class="details px-20 py-20 border-box">
      <el-row :gutter="20" type="flex" class="detail-row">
        <el-col :span="18" class="detail-col">
          <descriptions v-if="!showDesc" :span="6" :status="status" :row-data="rowData" :rules="rules"
            :columns="columns" ref="descriptionsRef">

            <template #contractReceivePaymentSlot="{ data }">
              <div class="flex items-center">
                <div>

                  <!--收款合同 -->

                  <el-select clearable v-model="contractReceivePaymentId" :disabled="data.disabled" filterable remote
                    reserve-keyword placeholder="请选择合同名称"
                    :remote-method="(e) => remoteMethod(e, 'contractReceivePaymentId')" :loading="selectLoading">
                    <el-option v-for="item in receivableContractOption" :key="item.id" :label="item.contractName"
                      @click.native="curOption(item, data, 'contractReceivePaymentId')" :value="item.id">
                    </el-option>
                  </el-select>
                </div>
                <el-button type="text" @click="openViewProject(contractReceivePaymentId, '2')"
                  v-if="contractReceivePaymentId">查看</el-button>
              </div>
            </template>
            <template #invoicePlanList>
              <InvoicePlanList
                v-model="invoicePlanListData"
                mode="invoice"
                :status="status"
                :editable-plan="status === 'add' || status === 'reAdd' || status === 'edit' || status === 'change'"
                :show-void="isFinance"
                :contractNoInvoiceAmount="contractNoInvoiceAmount"
                :contractTotalAmount="contractTotalAmount"
                :contractInvoicedAmount="contractInvoicedAmount"
                @void-batch="onVoidBatch"
              />
            </template>
          </descriptions>
          <auditCom v-if="toExamine && dialogDrawer" @refreshInitData="childReviewer"></auditCom>
        </el-col>
        <el-col :span="6" class="detail-col right-col">
          <div class="approval-progress">
            <div class="progress-box"  v-if="status !== 'add'">
              <div class="progress-title">审批流程</div>
              <div class="progress-desc-info flex flex-wrap">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                  <el-breadcrumb-item v-for="(item, index) in processDescInfo" :key="index">
                    <div class="items">
                      <el-avatar shape="square" size="large"
                          :src="item ? imageUrlprefix + item : defaultAvatar"></el-avatar>
                    </div>
                  </el-breadcrumb-item>
                </el-breadcrumb>
              </div>
            </div>
            <div class="progress-title" v-if="status !== 'add'">审批进度</div>
            <div class="progress-con" v-if="status !== 'add'">
              <el-timeline>
                <el-timeline-item v-for="(item, index) in processList" :key="index" size="large"
                  :icon="auditProcessStatus(item.auditStatus).icon" :color="auditProcessStatus(item.auditStatus).color">
                  <el-row :gutter="15">
                    <el-col :span="6">
                      <div>
                        <el-image v-if="item.typeLabel == '抄送人'" style="width: 40px;height: 40px;"
                          :src="require('@/assets/makeACopyFor.png')" fit="cover"></el-image>
                        <el-avatar shape="square" v-else size="large"
                          :src="item.avatar ? imageUrlprefix + item.avatar : defaultAvatar"></el-avatar>
                      </div>
                    </el-col>
                    <el-col :span="18" v-if="item.typeLabel == '抄送人'">
                      <div class="makeACopyFor-desc">
                        <div class="makeACopyFor-title">
                          {{ item.typeLabel }}
                        </div>
                        <div class="makeACopyFor-num">
                          已抄送{{ item.userList ? item.userList.length : 0 }}人
                        </div>
                        <div class="makeACopyFor-box flex justify-start items-center flex-wrap">
                          <div class="child-items" v-for="(cItem, cIndex) in item.userList" :key="cIndex">
                            <el-avatar shape="square" size="large"
                              :src="cItem.userAvatar ? imageUrlprefix + cItem.userAvatar : defaultAvatar"></el-avatar>
                            <div class="child-text">{{ cItem.userName }}</div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="18" v-else>
                      <div class="progress-desc">
                        <div><span>{{ item.name }}</span><span class="progress-time">{{ item.date }}</span></div>
                        <div>{{ item.typeLabel }}</div>
                        <div :style="{ color: auditProcessStatus(item.auditStatus).color, fontSize: '18px' }">{{
                          item.auditLabel }}</div>
                        <div class="signature-box flex justify-start items-center" v-if="item.signatureUrl">
                          <span class="signature-title">签名</span>
                          <el-image class="signature-img" :src="imageUrlprefix + item.signatureUrl"
                            fit="contain"></el-image>
                        </div>
                        <el-tooltip class="item" effect="dark" :content="item.auditComment" placement="top-start">
                          <p class="notes-text" v-if="item.auditStatus == 2">
                            {{ item.auditComment }}
                          </p>
                        </el-tooltip>
                      </div>
                    </el-col>
                  </el-row>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="details-footer px-20 py-20 border-box" v-if="status !== 'view'">
      <el-button type="primary" @click="submit()">提交</el-button>
      <el-button type="primary" @click="temporarilyStore()" v-if="status == 'add' || status == 'edit'">暂存</el-button>
      <el-button @click="clearForm()" v-if="status == 'add' || status == 'edit'">清空</el-button>
    </div>

    <view-other-details ref="viewProjectRef"></view-other-details>
  </el-drawer>
</template>

<script>
import descriptions from '@/components/descriptions/index.vue'
import { queryFinReceivedInvoiceDetailsApi, addFinReceivedInvoiceApi, editFinReceivedInvoiceApi, processFinReceivedInvoiceApi, reAddFinReceivedInvoiceApi, queryAuditProcessDescriptionApi, voidFinReceivedInvoiceItemApi } from '@/api/finReceivedInvoiceItem/index'
import { queryBasicOwnersListApi } from '@/api/basicInfo/index'
import {queryContractReceivePaymentDetailsApi, queryPageForLedgerListApi} from '@/api/receivableContract‌/index'
import { getContractInvoiceAndReceivedDataApi } from '@/api/paymentContract/index'
import { auditProcessStatus } from '@/utils/index'
import { dataPage } from "@/api/sys/dictData";
import auditCom from "@/components/auditCom/index.vue"
import viewOtherDetails from "@/components/viewOtherDetails/index.vue"
import InvoicePlanList from "./InvoicePlanList.vue"
export default {
  components: {
    auditCom,
    descriptions,
    viewOtherDetails,
    InvoicePlanList
  },
  props: {
    toExamine: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '开票详情'
    },
    status: {
      type: String,
      default: 'view'
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (value && /^1[3456789]\d{9}$/.test(value)) {
        callback()
      } else {
        callback(new Error('请输入正确的手机号码'))
      }
    }
    return {
      defaultAvatar: 'https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png',
      dialogDrawer: false,
      contractReceivePaymentId: "",
      correlationType: '1',
      selectLoading: false,
      loading: false,
      customerForm: {},
      showDesc: false,
      columns: [
        { key: 'contractReceivePaymentId', label: '关联合同', span: 6, placeholder: '请选择关联合同', disabled: true, defaultValue: '', slotName: 'contractReceivePaymentSlot' },
        {
          key: 'relatedItemsReceivePayment', height: 'auto', label: '关联项收款情况', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: false,
          columns: [
            { label: '总金额(元)', key: 'totalAmount', width: '120px', align: 'center', placeholder: '请输入阶段', input: 'input', required: true, defaultValue: "" },
            { label: '已开票金额(元)', key: 'invoicedAmount', width: '120px', placeholder: '请输入预计金额', align: 'center', input: 'input', defaultValue: "" },
            { label: '未开票金额(元)', key: 'noInvoicedAmount', width: '120px', placeholder: '请输入预计日期', align: 'center', input: 'date', defaultValue: "" },
            { label: '已收款金额(元)', key: 'receivedAmount', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "", color: '#67C23A', fontWeight: 'bold', headerColor: '#FFFFFF', headerBackgroundColor: '#67C23A', headerFontWeight: 'bold' },
            { label: '未收款金额(元)', key: 'noReceivedAmount', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
          ],
          defaultValue: []
        },
        {
          key: 'invoicePlanList', height: 'auto', label: '开票计划', span: 6, placeholder: '', disabled: true, input: 'slot', isShowAdd: true,

        },
        { key: 'invoiceOwnerUnitId', label: '开票单位', span: 6, placeholder: '请选择开票单位', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'unitName', valueKey: 'id' },
        { key: 'invoiceReserveDays', label: '预留开票时长(天)', span: 3, placeholder: '预留开票时长', input: 'input-number', type: 'text', disabled: true, defaultValue: '' },
        // { key: 'documentCount', label: '文件数量', span: 3, placeholder: '请输入文件数量', input: 'input-number', type: 'text', disabled: true, defaultValue: '' },
        { key: 'invoiceTypeCode', label: '开票类型', span: 6, placeholder: '请选择开票类型', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'dictLabel', valueKey: 'dictValue' },
        // { key: 'contractAmount', label: '已开票金额', span: 3, placeholder: '请输入已开票金额', input: 'input-number', type: 'text', disabled: true, defaultValue: '' },
        // { key: 'contractAmount', label: '未开票金额', span: 3, placeholder: '请输入未开票金额', input: 'input-number', type: 'text', disabled: true, defaultValue: '' },
        // {
        //   key: 'receivePaymentPlanList', height: 'auto', label: '回款计划', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: false,
        //   columns: [
        //     { label: '阶段', key: 'stage', width: '120px', align: 'center', placeholder: '请输入阶段', input: 'input', required: true, defaultValue: "", required: true, },
        //     { label: '预计金额', key: 'estimatedAmount', width: '120px', placeholder: '请输入预计金额', align: 'center', input: 'input', defaultValue: "", required: true, },
        //     { label: '预计日期', key: 'estimatedDate', width: '180px', placeholder: '请输入预计日期', align: 'center', input: 'date', defaultValue: "", required: true, },
        //     { label: '备注', key: 'note', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
        //   ],
        //   defaultValue: []
        // },
        // {
        //   key: 'receivedInvoiceItemList', height: 'auto', label: '开票明细', span: 6, placeholder: '', disabled: true, input: 'table', isShowAdd: true,
        //   columns: [
        //     { label: '名称', key: 'name', width: '120px', align: 'center', placeholder: '请输入名称', input: 'select', labelKey: 'dictLabel', valueKey: 'dictValue', required: true, defaultValue: "", required: true, option: [] },
        //     { label: '数量', key: 'count', width: '120px', placeholder: '请输入数量', align: 'center', input: 'input', defaultValue: "", required: true, },
        //     { label: '单价', key: 'unitPrice', width: '180px', placeholder: '请输入单价', align: 'center', input: 'input', defaultValue: "", required: true, },
        //     { label: '小计', key: 'totalAmount', width: '120px', align: 'center', placeholder: '请输入小计', input: 'input', defaultValue: "" },
        //     { label: '备注', key: 'note', width: '120px', align: 'center', placeholder: '请输入备注', input: 'input', defaultValue: "" },
        //   ],
        //   defaultValue: []
        // },
        { key: 'totalAmount', label: '合计金额(元)', span: 6, placeholder: '请输入合计金额', input: 'input-number', type: 'text', disabled: true, defaultValue: '' },
        { key: 'valueAddedTaxTaxpayerName', label: '增值税纳税人名称', span: 2, placeholder: '请输入增值税纳税人名称', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'taxpayerIdentificationNumber', label: '纳税人识别号', span: 2, placeholder: '请输入纳税人识别号', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'invoiceAddress', label: '开票地址', span: 2, placeholder: '请输入开票地址', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'invoiceBank', label: '开户银行', span: 2, placeholder: '请输入开户银行', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'invoiceBankAccount', label: '银行账号', span: 2, placeholder: '请输入银行账号', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        { key: 'invoicePhone', label: '电话', span: 2, placeholder: '请输入电话', input: 'input', type: 'text', disabled: true, defaultValue: '' },
        // { key: 'useSealOwnerUnitId', label: '开票单位', span: 3, placeholder: '请选择开票单位', input: 'select', type: 'text', disabled: true, defaultValue: '', option: [], labelKey: 'unitName', valueKey: 'id'  },
        { key: 'attachment', height: '450px', label: '附件', span: 6, placeholder: '请上传附件上传', uploadType: 'project', input: 'upload', fileMaxSize: 20, disabled: true, defaultValue: [], accept: '.xls,.xlsx,.pdf,.doc,.docx,.txt,.bmp,.jpg,.jpeg,.png,.tif,.gif,.svg,.webp,.zip,.rar,.7z', limit: 50, },
        { key: 'notes', label: '备注', span: 6, placeholder: '请输入备注', input: 'textarea', type: 'textarea', disabled: true, defaultValue: '' },
      ],
      rowData: {},
      cloneColumns: [],//复制一遍
      rules: {
        receivedInvoiceItemList: [],
        invoiceOwnerUnitId: [
          { required: true, message: '请选择开票单位', trigger: 'change' },
        ],
        invoiceReserveDays: [
          { required: true, message: '请输入预留开票时长', trigger: 'blur' },
        ],
        invoiceTypeCode: [
          { required: true, message: '请选择开票类型', trigger: 'change' }
        ],
        valueAddedTaxTaxpayerName: [
          { required: true, message: '请输入增值税纳税人名称', trigger: 'blur' },
        ],
        taxpayerIdentificationNumber: [
          { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
        ],
        invoiceAddress: [
          { required: true, message: '请输入开票地址', trigger: 'blur' }
        ],
        invoiceBank: [
          { required: true, message: '请输入开户银行', trigger: 'blur' }
        ],
        invoiceBankAccount: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        invoicePhone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ]
      },
      processList: [],
      processDescInfo: [],
      receivableContractOption: [],
      invoicePlanListData: [],
      contractNoInvoiceAmount: 0,
      contractTotalAmount: 0,
      contractInvoicedAmount: 0
    }
  },
  mounted() {
    this.dictOption('invoice_type');
    this.dictOption('invoice_content');
    this.getOwnersList();
    this.getLedgerContractList();
    this.cloneColumns = JSON.parse(JSON.stringify(this.columns))

  },
  computed: {
    // 是否财务角色：仅财务账号可见“作废”按钮（如实际系统角色标识不同，请调整下方正则）
    isFinance() {
      const roles = (this.$store && this.$store.getters && this.$store.getters.roles) || []
      return roles.some(r => /finance|cw|财务|fin/i.test(String(r)))
    }
  },
  methods: {
    auditProcessStatus,
    //作废已开票批次：扣减已开票金额并同步关联项收款情况
    onVoidBatch(row) {
      if (String(row.status) !== '1') return
      // 弹框填写作废原因：必填，提交后写入该批次备注（收款合同侧可见）
      this.$prompt('作废后该批次已开票金额将扣减，且不可恢复。请填写作废原因（将写入备注）。', '作废确认', {
        confirmButtonText: '确定作废',
        cancelButtonText: '取消',
        inputType: 'textarea',
        inputPlaceholder: '请输入作废原因',
        inputValidator: (val) => {
          if (!val || !String(val).trim()) return '作废原因不能为空'
          return true
        },
        type: 'warning'
      }).then(({ value }) => {
        const reason = String(value).trim()
        const voidAmount = Number(row.invoicedAmount) || 0
        voidFinReceivedInvoiceItemApi({ id: row.id, voidReason: reason }).then(res => {
          if (res && res.code === 200) {
            // 后端已将该批次置为已作废、已开票金额回 0，前端同步显示
            this.$set(row, 'status', '5')
            this.$set(row, 'invoicedAmount', 0)
            this.$set(row, 'unInvoicedAmount', Number(row.planInvoicingAmount) || 0)
            this.$set(row, 'noInvoiceAmount', Number(row.planInvoicingAmount) || 0)
            this.$set(row, 'planRemark', '作废原因：' + reason)
            // 同步“关联项收款情况”已开票金额：整体扣减
            this.contractInvoicedAmount = Math.max(0, Number(this.contractInvoicedAmount) - voidAmount)
            this.updateRelatedInvoicedAmount(voidAmount)
            this.$message.success('作废成功')
          } else {
            this.$message.warning((res && res.msg) || '作废未成功，请确认后端接口')
          }
        }).catch(() => {
          this.$message.warning('作废请求失败，请确认后端接口')
        })
      }).catch(() => {})
    },
    // 扣减关联项收款情况表格中的已开票金额，并同步未开票金额
    updateRelatedInvoicedAmount(voidAmount) {
      const col = this.columns.find(c => c.key === 'relatedItemsReceivePayment')
      if (col && Array.isArray(col.defaultValue)) {
        col.defaultValue.forEach(item => {
          const invoiced = Math.max(0, Number(item.invoicedAmount || 0) - voidAmount)
          item.invoicedAmount = invoiced
          const total = Number(item.totalAmount || 0)
          item.noInvoicedAmount = Math.max(0, total - invoiced)
        })
      }
    },
    //核心方法 判断是否是新增 还是编辑  
    async openDrawer(row) {
      this.dialogDrawer = true;
      this.$nextTick(() => {
        switch (this.status) {
          case 'view':
            this.queryDetails({ id: row.id })
            break;
          case 'add':
            //新增把原有的数据设置默认值；开票计划默认展示一行（收起状态）
            this.showDesc = true;
            this.invoicePlanListData = this.createDefaultInvoicePlanList()
            this.contractNoInvoiceAmount = 0
            this.contractTotalAmount = 0
            this.contractInvoicedAmount = 0
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = false;
              this.columns[i].defaultValue = this.cloneColumns[i].defaultValue;
            }
            this.$nextTick(() => {
              this.showDesc = false;
            })
            this.reverseDisplayList({}, 'contractReceivePaymentId')
            break;
          case 'edit':
            this.queryDetails({ id: row.id })
            break;
          case 'change':
            this.queryDetails({ id: row.id })
            break;
          case 'reAdd':
            this.queryDetails({ id: row.id })
            break;
          default:
            break;
        }
      })
    },
    //关闭弹框
    closeDrawer() {
      this.dialogDrawer = false;
      this.contractReceivePaymentId = "";
      this.correlationType = '1';
      this.invoicePlanListData = [];
      this.contractNoInvoiceAmount = 0;
      this.contractTotalAmount = 0;
      this.contractInvoicedAmount = 0;
    },
    //详情查询
    queryDetails(params) {
      this.loading = true;
      this.showDesc = true;
      queryFinReceivedInvoiceDetailsApi(params).then(res => {
        this.loading = false;
        this.showDesc = false;
        if (res.code == 200) {
          this.rowData = res.data;
          this.invoicePlanListData = res.data.finReceivedInvoicePlanDtoList || []
          if (this.status !== 'add') {
            this.contractReceivePaymentId = res.data.contractReceivePaymentId;
            this.correlationType = res.data.correlationType;
            for (let i = 0; i < this.columns.length; i++) {
              this.columns[i].disabled = this.status == 'view' ? true : false;
              if (this.columns[i].key == 'relatedItemsReceivePayment') {
                this.reverseDisplayList({ id: res.data.contractReceivePaymentId }, 'contractReceivePaymentId')
              } else {
                this.columns[i].defaultValue = this.rowData[this.columns[i].key];
              }

            }

          }


        }
      }).catch(err => {
        this.loading = false;
      })
      this.queryProcessProject(params)
      this.qeuryAuditProcessDescription(params)
    },
    //提交
    submit(status = 1) {
      this.$refs.descriptionsRef.submit().then((formData = {}) => {
        if ('relatedItemsReceivePayment' in formData) {
          delete formData.relatedItemsReceivePayment
        }
        // 至少勾选一期开票批次
        if (!(this.invoicePlanListData || []).some(row => Number(row.selected) === 1)) {
          this.$message.warning('请至少选择一期开票批次')
          return
        }
        // 新增/重新发起/撤销后修改/编辑：若所有开票批次未填“开票日期”，提交前二次确认
        if (status !== 0 && ['add', 'reAdd', 'change', 'edit'].includes(this.status)) {
          const hasInvoiceDate = (this.invoicePlanListData || []).some(p => p.invoiceDate)
          if (!hasInvoiceDate) {
            this.$confirm('您还没有选择开票日期，是否确认提交?', '提示', {
              confirmButtonText: '确认提交',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.doSubmit(formData, status)
            }).catch(() => {})
            return
          }
        }
        this.doSubmit(formData, status)
      }).catch(() => {})
    },
    // 真正提交（表单必填校验已通过）
    doSubmit(formData, status) {
        let params = {
          invoiceStatus: status,
          ...formData,
          contractReceivePaymentId: this.contractReceivePaymentId,
          correlationType: this.correlationType,
          finReceivedInvoicePlanDtoList: this.invoicePlanListData
        }
        // 取各期“开票日期”中最晚的一个回写父级，保证列表/台账等单日期展示不缺失
        const planDates = (this.invoicePlanListData || []).map(p => p.invoiceDate).filter(Boolean).sort()
        params.invoiceDate = planDates.length ? planDates[planDates.length - 1] : ''
        this.loading = true;
        if (this.status == 'add') {
          addFinReceivedInvoiceApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        } else if (this.status == 'reAdd') {
          reAddFinReceivedInvoiceApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            } else {
              this.$message({
                message: res.msg,
                type: 'warning'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        } else {
          editFinReceivedInvoiceApi(params).then(res => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success'
              });
            }
            this.loading = false;
            this.closeDrawer();
            this.queryData();
          }).catch(err => {
            this.loading = false;
          })
        }
    },
    //暂存
    temporarilyStore() {
      this.submit(0);
    },
    //清空描述组件form，同时重置开票计划为一行默认数据
    clearForm() {
      this.contractReceivePaymentId = "";
      this.correlationType = '1';
      this.contractNoInvoiceAmount = 0;
      this.contractTotalAmount = 0;
      this.contractInvoicedAmount = 0;
      this.invoicePlanListData = this.createDefaultInvoicePlanList();
      this.$refs.descriptionsRef.resetForm()
    },
    // 开票计划默认一行（收起）
    createDefaultInvoicePlanList() {
      return []
    },
    //查询列表
    queryData() {
      this.$emit('initQueryData')
    },
    async dictOption(type) {
      let params = {
        query: {
          dictType: type
        }
      }
      dataPage(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'invoiceTypeCode' && type == 'invoice_type') {
              item.option = res.data.rows || []
            } else if (item.key == 'receivedInvoiceItemList' && type == 'invoice_content') {
              item.columns[0].option = res.data.rows || []
            }
            return item
          })
        }
      })
    },
    //开票单位
    getOwnersList() {
      let params = {
        unitName: ""
      }
      queryBasicOwnersListApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'invoiceOwnerUnitId') {
              item.option = res.data || []
            }
            return item
          })
        }
      })
    },
    //查询收款合同台账
    getLedgerContractList(v = '') {
      let params = {
        params: {
          contractName:v,
        }
        // 不传 contractStatus：后端 listJsonAble 在 contractStatus 为空时按 able=1 过滤，
        // 返回 审核中(1)/已通过(2) 的合同，使“变更走流程中(审核中)”的收款合同也能被选择
      }
      this.selectLoading = true;
      queryPageForLedgerListApi(params).then(res => {
        this.selectLoading = false;
        if (res.code == 200) {
          this.receivableContractOption = res.data;
        }
      })
    },
    // 通过合同-获取开票和收款数据
    getInvoiceAndReceivedDataContract(id) {
      let params = {
        id,
      }
      getContractInvoiceAndReceivedDataApi(params).then(res => {
        if (res.code == 200) {
          this.columns.map(item => {
            if (item.key == 'relatedItemsReceivePayment') {
              item.defaultValue = res.data ? [res.data] : [] || []
            }
            return item
          })
          this.contractNoInvoiceAmount = Number(res.data ? (res.data.noInvoicedAmount || 0) : 0)
          this.contractTotalAmount = Number(res.data ? (res.data.totalAmount || 0) : 0)
          this.contractInvoicedAmount = Number(res.data ? (res.data.invoicedAmount || 0) : 0)
        }
      })
    },
    remoteMethod(query, current = '') {
      if (query !== '') {
        switch (current) {
          case 'contractReceivePaymentId':
            this.getLedgerContractList(query)
            break;
          default:
            break;
        }
      } else {
        this.projectOptions = [];
        this.receivableContractOption = [];
      }
    },
    //审批进度
    queryProcessProject(params) {
      processFinReceivedInvoiceApi(params).then(res => {
        if (res.code == 200) {
          this.processList = res.data;
        }
      })
    },
    qeuryAuditProcessDescription(params) {
      queryAuditProcessDescriptionApi(params).then(res => {
        if (res.code == 200) {
          this.processDescInfo = res.data.avatars;
        }
      })
    },
    //下拉当前选中
    curOption(v = {}, slotData, current) {
      let item = v;
      if (this.status == 'add' || this.status == 'edit' || this.status == 'change' || this.status == 'reAdd') {
        for (let i = 0; i < this.columns.length; i++) {
          for (let key in item) {
            if (this.columns[i].key == key && !this.columns[i].slotName) {
              this.columns[i].disabled = false;
              // if(this.columns[i].key == 'receivePaymentPlanList'){
              //   console.log(item,'v')
              //   this.columns[i].defaultValue = item.makePaymentPlanList || [];
              // }
            }
          }
        }
      }
      this.reverseDisplayList(v, current);
      // 获取合同详情
      this.getContractDetails(item.id)
    },
    getContractDetails(id) {
      let params = {
        id,
      }
      queryContractReceivePaymentDetailsApi(params).then(res => {
        if (res.code == 200) {
          this.invoicePlanListData = res.data.finReceivedInvoicePlanDtoList || []
        }
      })
    },
    //关联收款情况反显
    reverseDisplayList(data = {}, current) {

      if (current) {
        if (current == 'contractReceivePaymentId' && data.hasOwnProperty('id')) {
          this.getInvoiceAndReceivedDataContract(data.id)
        } else {
          this.contractNoInvoiceAmount = 0
          this.contractTotalAmount = 0
          this.contractInvoicedAmount = 0
          this.columns.map(item => {
            if (item.key == 'relatedItemsReceivePayment') {
              item.defaultValue = [
                {
                  totalAmount: '--',
                  noInvoicedAmount: '--',
                  noReceivedAmount: '--',
                  receivedAmount: '--',
                  invoicedAmount: '--'
                }
              ]
            }
            return item
          })
        }
      }
    },
    //关闭详情 刷新页面
    childReviewer(row) {
      this.closeDrawer()
      this.$emit('parReviewer')
    },
    openViewProject(id, correlationType) {
      this.$refs.viewProjectRef.viewProject(id, correlationType)
    }
  }
}
</script>

<style scoped lang="scss">
.details-footer {
  height: 50px;
  line-height: 50px;
  text-align: right;
}

.progress-box{
  padding: 5px;
  box-sizing: border-box;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  border-radius: 5px;
  margin-bottom: 5px;
  background: #285af1;
  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
    color: #fff;
  }
  .progress-desc-info {
    padding: 10px 0px 10px 0px;

    .items {
      font-size: 15px;
      display: inline-block;
      vertical-align: middle; 
    }
  }
}
.approval-progress {
  

  .progress-title {
    font-size: 18px;
    padding-bottom: 10px;
  }

  .progress-con {
    .progress-desc {
      line-height: 20px;
      color: #303133;

      .progress-time {
        margin-left: 10px;
        color: #909399;
      }

      .notes-text {
        display: -webkit-box;
        /* 设置为弹性盒子模型 */
        -webkit-box-orient: vertical;
        /* 垂直排列 */
        -webkit-line-clamp: 2;
        /* 显示最多 3 行 */
        overflow: hidden;
        /* 隐藏超出的部分 */
        text-overflow: ellipsis;
        /* 使用省略号 */
      }

      .signature-box {
        width: 180px;
        height: 50px;
        overflow: hidden;

        .signature-title {
          display: block;
          width: 40px;
        }

        .signature-img {
          margin-left: 10px;
          width: 180px;
        }
      }
    }

    .makeACopyFor-desc {
      line-height: 20px;
      color: #303133;

      .makeACopyFor-title {}

      .makeACopyFor-num {
        color: #909399;
      }

      .makeACopyFor-box {
        .child-items {
          padding-right: 5px;
          box-sizing: border-box;

          .child-text {
            text-align: center;
          }
        }
      }
    }
  }
}

::v-deep .el-drawer__header {
  color: #000;
  font-size: 18px;
}

::v-deep .el-breadcrumb__separator {
  color: #fff;
}

.details {
  // 强制外层 el-row 使用 flex 布局，避免 float 导致宽表格溢出到右列
  ::v-deep .detail-row {
    display: flex !important;
    flex-wrap: nowrap !important;
  }

  ::v-deep .detail-row > .el-col {
    float: none !important;
    min-width: 0 !important;
  }

  // 右列在 rtl 布局下溢出会向左跑，必须自己产生滚动条而不是盖住左列
  ::v-deep .right-col {
    overflow-x: auto !important;
  }

  // 固定 el-descriptions 的表格布局，让开票计划单元格宽度受限于左列，从而触发内部横向滚动
  ::v-deep .el-descriptions__table {
    table-layout: fixed !important;
    width: 100% !important;
  }
}
</style>

<style>
/* 兜底：防止 scoped 样式未生效时开票计划表格撑破布局 */
.fin-received-invoice-detail .detail-row {
  display: flex !important;
  flex-wrap: nowrap !important;
}

.fin-received-invoice-detail .detail-row > .el-col {
  float: none !important;
  min-width: 0 !important;
}

.fin-received-invoice-detail .right-col {
  overflow-x: auto !important;
}

.fin-received-invoice-detail .el-descriptions__table {
  table-layout: fixed !important;
  width: 100% !important;
}
</style>